import { createFileRoute } from '@tanstack/react-router';
import { CommunicationAnswerDocumentPage } from '@/pages/member-portal/communications/CommunicationAnswerDocumentPage';

function MemberPortalCommunicationAnswerDocumentRoute() {
	const { id, companyId } = Route.useParams();
	return <CommunicationAnswerDocumentPage communicationId={id} memberCompanyId={companyId} />;
}

export const Route = createFileRoute(
	'/_authenticated/_app/member-portal/manage/communications/$id_/responses/$companyId',
)({
	component: MemberPortalCommunicationAnswerDocumentRoute,
});
